import React, { useState, useEffect } from "react";
import "react-datepicker/dist/react-datepicker.css";
import {
  Card,
  CardBody,
  CardTitle,
  Col,
  Row,
  Button,
  CardHeader,
} from "reactstrap";
import { toast } from "react-toastify";

const MachineManualStatus = ({ selectedDate, selectedShift, selectedMachine ,part,isManual}) => {
  const [childParts, setChildParts] = useState([]);
  const authToken = localStorage.getItem("access");
  const [isLoading, setIsLoading] = useState(false);
  const [selectedChildPart, setSelectedChildPart] = useState(4);
  const [operators, setOperators] = useState([]);
  const [savedTimeSlots, setSavedTimeSlots] = useState([]);
  const [pdfBlobUrl, setPdfBlobUrl] = useState(null);
   const selectedOperator_name= localStorage.getItem('name')
  const selectedOperator_id= localStorage.getItem('id')
const [formFields, setFormFields] = useState({
  manualStartTime: "",
  manualEndTime: "",
  manualReason: "",
  manualComment: "",
  manualPart: "",
});
const [manualStopList, setManualStopList] = useState([]);

  useEffect(() => {
    if (selectedDate && selectedShift&& selectedMachine) {
      handlePreview();
    }
  }, [selectedDate, selectedShift, selectedMachine]);
   useEffect(() => {
    fetchOperator();
    fetchChildParts();
   
  }, [selectedMachine, selectedDate, selectedShift]);

  const fetchChildParts = async () => {
    try {
      const response = await fetch("https://api.hanoch.in/api/parts");
      if (response.ok) {
        const parts = await response.json();
        setChildParts(parts);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
 
 
  const getCurrentShift = () => {
    const now = new Date();
    const hours = now.getHours();

    if (hours >= 6 && hours < 14) {
      return 1; // Shift 1: 6am to 2pm
    } else if (hours >= 14 && hours < 22) {
      return 2; // Shift 2: 2pm to 10pm
    } else {
      return 3; // Shift 3: 10pm to 6am
    }
  };

  //let pdfBlobUrl = null;
  const handlePreview = async () => {
    if (!selectedDate || !selectedShift ||!selectedMachine) {
      toast.error("Please select date, shift and machine.");
      return;
    }

  
    const formattedDate = new Date(selectedDate).toISOString().split("T")[0];
    const url = `https://api.hanoch.in/production-film/generate-production-pdf/?date=${formattedDate}&shift=${selectedShift}&machine=${selectedMachine}`;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch report.");
      }

      const blob = await response.blob();
      const pdfUrl = window.URL.createObjectURL(blob);
      setPdfBlobUrl(pdfUrl); // Save it to state

    } catch (error) {
      console.error("Error previewing report:", error);
      toast.error("Failed to preview report.");
    }
  };

 
 

  const handleDownload = () => {
    if (!pdfBlobUrl) {
      toast.error("Please preview the report first.");
      return;
    }

    const formattedDate = new Date(selectedDate).toISOString().split("T")[0];
    const link = document.createElement("a");
    link.href = pdfBlobUrl;
    link.setAttribute(
      "download",
      `Report_${formattedDate}_Shift${selectedShift}_Machine${selectedMachine}.pdf`
    );
    document.body.appendChild(link);
    link.click();
    link.remove();
  };



const handleManualSubmit = async () => {
  if (manualStopList.length === 0) {
    toast.error("Please add at least one entry.");
    return;
  }

  try {
    setIsLoading(true);

    for (let entry of manualStopList) {
      const payload = {
        start_time: entry.manualStartTime,
        end_time: entry.manualEndTime,
        reason_type: entry.manualReason,
        status: "stopped",
        comments: entry.manualComment,
        operator_id: selectedOperator_id,
        machine_id: selectedMachine,
        date: selectedDate,
        shift: selectedShift,
        part_id: entry.manualReason === "Changeover" ? entry.manualPart : part,
      };

      const response = await fetch("https://api.hanoch.in/production-film/manual_machine_stop_reason/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();
      if (!response.ok) {
        toast.error(result.error || "Error saving one of the entries.");
        return;
      }
    }

    toast.success("All manual stop entries submitted successfully.");
    setManualStopList([]);
    handlePreview();

  } catch (error) {
    console.error("Submit error:", error);
    toast.error("Failed to submit entries.");
  } finally {
    setIsLoading(false);
  }
};
 const addEntryToList = () => {
    const { manualStartTime, manualEndTime, manualReason, manualComment, manualPart } = formFields;
    if (!manualStartTime || !manualEndTime || !manualReason || !manualComment) {
      toast.error("Please fill in all required fields.");
      return;
    }

    if (manualReason === "Changeover" && !manualPart) {
      toast.error("Please select part for Changeover.");
      return;
    }

    setManualStopList((prev) => [...prev, formFields]);
    setFormFields({
      manualStartTime: "",
      manualEndTime: "",
      manualReason: "",
      manualComment: "",
      manualPart: "",
    });
  };

 

  const fetchOperator = async () => {
    try {
      const response = await fetch(
        "https://api.hanoch.in/users/operators",
      );
      if (response.ok) {
        const data = await response.json();
        setOperators(data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormFields((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleRefresh = async (e) => {
    e.preventDefault();
    //handle cancel function logic
    setFormFields({
      comment: "",
      time: "",
      id: "",

    });
  };
  const handlePartChange = (event) => {
    const selectedId = event.target.value;
    setSelectedChildPart(event.target.value);
  };
  return (
    <>
      <Col xl={6} style={{ marginBottom: "1.5rem" }}>
        <Card>
          <CardHeader>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">Production film</div>
            </div>
          </CardHeader>
          <CardBody>
            <div className="border rounded p-3 mb-3 shadow-sm">
              <h6>Manual Stop Entry</h6>
              <Row className="align-items-end">
                <Col md={3}>
                  <label className="col-form-label">Start-time</label>
                  <input
                    type="time"
                    className="form-control mb-1"
                    value={formFields.manualStartTime}
                    onChange={(e) =>
                      setFormFields((prev) => ({ ...prev, manualStartTime: e.target.value }))
                    }
                  />
                </Col>
                <Col md={3}>
                  <label className="col-form-label">End-time</label>
                  <input
                    type="time"
                    className="form-control mb-1"
                    value={formFields.manualEndTime}
                    onChange={(e) =>
                      setFormFields((prev) => ({ ...prev, manualEndTime: e.target.value }))
                    }
                  />
                </Col>
                <Col md={3}>
                  <label className="col-form-label">Reason</label>
                  <select
                    className="form-control mb-1"
                    value={formFields.manualReason}
                    onChange={(e) =>
                      setFormFields((prev) => ({ ...prev, manualReason: e.target.value }))
                    }
                  >
                    <option value="">Select reason</option>
                    <option value="Changeover">Changeover</option>
                    <option value="Breakdown">Breakdown</option>
                    <option value="Material Unavailable">Material Unavailable</option>
                    <option value="People Unavailable">People Unavailable</option>
                    <option value="Planned Stop">Planned Stop</option>
                  </select>
                </Col>

                {formFields.manualReason === "Changeover" && (
                  <Col md={3}>
                    <label className="col-form-label">Part</label>
                    <select
                      className="form-control"
                      value={formFields.manualPart}
                      onChange={(e) =>
                        setFormFields((prev) => ({ ...prev, manualPart: e.target.value }))
                      }
                    >
                      <option value="">Select part</option>
                      {childParts.map((part) => (
                        <option key={part.id} value={part.id}>
                          {part.name}
                        </option>
                      ))}
                    </select>
                  </Col>
                )}

                <Col md={3}>
                  <label className="col-form-label">Comment</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter comment"
                    value={formFields.manualComment}
                    onChange={(e) =>
                      setFormFields((prev) => ({ ...prev, manualComment: e.target.value }))
                    }
                  />
                </Col>

                <Col md={4}>
                  <Button color="primary" onClick={addEntryToList}>
                    + Add Entry
                  </Button>
                </Col>
              </Row>
            </div>

            {manualStopList.length > 0 && (
              <>
                <div className="mt-3">
                  <h6>Entries Added</h6>
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>Start</th>
                        <th>End</th>
                        <th>Reason</th>
                        <th>Comment</th>
                        <th>Part</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {manualStopList.map((entry, idx) => (
                        <tr key={idx}>
                          <td>{entry.manualStartTime}</td>
                          <td>{entry.manualEndTime}</td>
                          <td>{entry.manualReason}</td>
                          <td>{entry.manualComment}</td>
                          <td>
                            {entry.manualReason === "Changeover"
                              ? childParts.find((p) => p.id === parseInt(entry.manualPart))?.name || "—"
                              : "—"}
                          </td>
                          <td>
                            <Button
                              color="danger"
                              size="sm"
                              onClick={() => {
                                const updated = [...manualStopList];
                                updated.splice(idx, 1);
                                setManualStopList(updated);
                              }}
                            >
                              Remove
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>

                  <Button color="success" onClick={handleManualSubmit}>
                    Submit All
                  </Button>
                </div>
              </>
            )}
          </CardBody>
        </Card>

        {isLoading ? (
          <div className="text-center">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : (
          pdfBlobUrl && (
            <div style={{ height: "600px", marginTop: "20px" }}>
              <iframe
                src={pdfBlobUrl}
                width="100%"
                height="100%"
                title="PDF Preview"
                style={{ border: "none" }}
              ></iframe>
            </div>
          )
        )}
      </Col>
    </>
  );
};

export default MachineManualStatus;
